let _initProto, _initClass, _init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_portal, _init_extra_portal, _init_matchAnchorWidth, _init_extra_matchAnchorWidth, _init_offset, _init_extra_offset, _init_anchor, _init_extra_anchor, _init_variant, _init_extra_variant, _init_surfaceTarget, _init_extra_surfaceTarget, _init_hostTarget, _init_extra_hostTarget, _init_openChangeEvent, _init_extra_openChangeEvent, _initProto2, _initClass2, _init_open2, _init_extra_open2, _init_rootTarget, _init_extra_rootTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, bound, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { isServer } from "@ecopages/radiant/is-server";
import { PopoverController, shouldDismissPopoverFocus, shouldDismissPopoverPointer } from "../shared/popover-controller";
let _RuiPopover;
class RuiPopover extends RadiantElement {
  static {
    ({
      e: [_init_open, _init_extra_open, _init_placement, _init_extra_placement, _init_portal, _init_extra_portal, _init_matchAnchorWidth, _init_extra_matchAnchorWidth, _init_offset, _init_extra_offset, _init_anchor, _init_extra_anchor, _init_variant, _init_extra_variant, _init_surfaceTarget, _init_extra_surfaceTarget, _init_hostTarget, _init_extra_hostTarget, _init_openChangeEvent, _init_extra_openChangeEvent, _initProto],
      c: [_RuiPopover, _initClass]
    } = _applyDecs(this, [customElement("rui-popover")], [[prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "open"], [prop({
      type: String,
      defaultValue: "bottom"
    }), 0, "placement"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "portal"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "matchAnchorWidth"], [prop({
      type: Number,
      defaultValue: 8
    }), 0, "offset"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "anchor"], [prop({
      type: String,
      defaultValue: "default"
    }), 0, "variant"], [query({
      ref: "surface"
    }), 0, "surfaceTarget"], [query({
      ref: "host"
    }), 0, "hostTarget"], [event({
      name: "rui-open-change",
      bubbles: true,
      composed: true
    }), 0, "openChangeEvent"], [[bound, onUpdated(["open", "placement", "portal", "matchAnchorWidth", "offset", "anchor"])], 2, "syncPopover"], [onEvent({
      document: true,
      type: "pointerdown"
    }), 2, "onDocumentPointerDown"], [onEvent({
      ref: "host",
      type: "focusout"
    }), 2, "onFocusOut"], [bound, 2, "onExternalAnchorClick"], [onEvent({
      document: true,
      type: "keydown"
    }), 2, "onDocumentKeydown"]], 0, void 0, RadiantElement));
  }
  open = (_initProto(this), _init_open(this));
  placement = (_init_extra_open(this), _init_placement(this));
  portal = (_init_extra_placement(this), _init_portal(this));
  matchAnchorWidth = (_init_extra_portal(this), _init_matchAnchorWidth(this));
  offset = (_init_extra_matchAnchorWidth(this), _init_offset(this));
  anchor = (_init_extra_offset(this), _init_anchor(this));
  variant = (_init_extra_anchor(this), _init_variant(this));
  surfaceTarget = (_init_extra_variant(this), _init_surfaceTarget(this));
  hostTarget = (_init_extra_surfaceTarget(this), _init_hostTarget(this));
  openChangeEvent = (_init_extra_hostTarget(this), _init_openChangeEvent(this));
  surfaceId = (_init_extra_openChangeEvent(this), `rui-popover-${Math.random().toString(36).slice(2, 9)}`);
  controller = null;
  anchorClickTarget = null;
  onConnected() {
    this.syncPopover();
  }
  disconnectedCallback() {
    this.unbindExternalAnchorClick();
    this.controller?.destroy();
    this.controller = null;
    super.disconnectedCallback();
  }
  getAnchorElement() {
    const triggerHost = this.closest("rui-popover-trigger");
    const triggerFromHost = triggerHost?.querySelector("[data-popover-trigger]");
    if (triggerFromHost instanceof HTMLElement) {
      return resolvePopoverAnchor(triggerFromHost);
    }
    const slottedTrigger = this.querySelector("[data-popover-trigger]");
    if (slottedTrigger instanceof HTMLElement) {
      return resolvePopoverAnchor(slottedTrigger);
    }
    const selector = this.anchor.trim();
    if (selector) {
      const external = document.querySelector(selector);
      if (external instanceof HTMLElement) {
        return resolvePopoverAnchor(external);
      }
    }
    return null;
  }
  ensureController() {
    if (!this.controller) {
      this.controller = new PopoverController({
        getAnchor: () => this.getAnchorElement(),
        getFloating: () => this.surfaceTarget,
        getOpen: () => this.open,
        getPlacement: () => this.placement,
        gap: this.offset,
        portal: this.portal,
        matchAnchorWidth: this.matchAnchorWidth
      });
    }
    return this.controller;
  }
  syncPopover() {
    const anchor = this.getAnchorElement();
    const surface = this.surfaceTarget;
    if (surface) {
      surface.id = this.surfaceId;
    }
    if (anchor) {
      anchor.setAttribute("aria-controls", this.surfaceId);
      anchor.setAttribute("aria-expanded", String(this.open));
    }
    this.syncExternalAnchorClick(anchor);
    const controller = this.ensureController();
    controller.updateConfig({
      getAnchor: () => this.getAnchorElement(),
      getFloating: () => this.surfaceTarget,
      getOpen: () => this.open,
      getPlacement: () => this.placement,
      gap: this.offset,
      portal: this.portal,
      matchAnchorWidth: this.matchAnchorWidth
    });
    controller.sync();
  }
  setOpen(next, emit = true) {
    if (this.open === next) {
      this.syncPopover();
      return;
    }
    this.open = next;
    if (emit) {
      this.openChangeEvent.emit({
        open: next
      });
    }
    this.syncPopover();
  }
  onDocumentPointerDown(event2) {
    if (!this.open) {
      return;
    }
    const target = event2.target;
    if (!shouldDismissPopoverPointer(this.getAnchorElement(), this.controller?.getFloatingElement() ?? this.surfaceTarget, target)) {
      return;
    }
    this.setOpen(false);
  }
  onFocusOut(event2) {
    if (!this.open) {
      return;
    }
    if (!shouldDismissPopoverFocus(this.getAnchorElement(), this.controller?.getFloatingElement() ?? this.surfaceTarget, event2.relatedTarget)) {
      return;
    }
    this.setOpen(false);
  }
  usesExternalAnchor() {
    if (!this.anchor.trim()) {
      return false;
    }
    if (this.closest("rui-popover-trigger")) {
      return false;
    }
    return !this.querySelector("[data-popover-trigger]");
  }
  syncExternalAnchorClick(anchor) {
    if (!this.usesExternalAnchor() || !anchor) {
      this.unbindExternalAnchorClick();
      return;
    }
    if (this.anchorClickTarget === anchor) {
      return;
    }
    this.unbindExternalAnchorClick();
    anchor.addEventListener("click", this.onExternalAnchorClick);
    this.anchorClickTarget = anchor;
  }
  unbindExternalAnchorClick() {
    if (!this.anchorClickTarget) {
      return;
    }
    this.anchorClickTarget.removeEventListener("click", this.onExternalAnchorClick);
    this.anchorClickTarget = null;
  }
  onExternalAnchorClick() {
    this.setOpen(!this.open);
  }
  onDocumentKeydown(event2) {
    if (!this.open || event2.key !== "Escape") {
      return;
    }
    event2.preventDefault();
    this.setOpen(false);
    const anchor = this.getAnchorElement();
    anchor?.focus();
  }
  static {
    _initClass();
  }
}
export { _RuiPopover as RuiPopover };
let _RuiPopoverTrigger;
class RuiPopoverTrigger extends RadiantElement {
  static {
    ({
      e: [_init_open2, _init_extra_open2, _init_rootTarget, _init_extra_rootTarget, _initProto2],
      c: [_RuiPopoverTrigger, _initClass2]
    } = _applyDecs(this, [customElement("rui-popover-trigger")], [[prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "open"], [query({
      ref: "root"
    }), 0, "rootTarget"], [[bound, onUpdated(["open"])], 2, "syncToPopover"], [onEvent({
      ref: "root",
      type: "click"
    }), 2, "onHostClick"], [onEvent({
      selector: "rui-popover",
      type: "rui-open-change"
    }), 2, "onPopoverOpenChange"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_rootTarget(this);
  }
  open = (_initProto2(this), _init_open2(this));
  rootTarget = (_init_extra_open2(this), _init_rootTarget(this));
  getPopover() {
    return this.querySelector("rui-popover");
  }
  onConnected() {
    this.syncToPopover();
  }
  syncToPopover() {
    if (isServer) {
      return;
    }
    const popover = this.getPopover();
    if (!popover || typeof popover.setOpen !== "function") {
      return;
    }
    if (popover.open !== this.open) {
      popover.setOpen(this.open, false);
    }
  }
  onHostClick(event2) {
    const target = event2.target;
    if (!target?.closest("[data-popover-trigger]")) {
      return;
    }
    this.open = !this.open;
    const popover = this.getPopover();
    if (popover && typeof popover.setOpen === "function") {
      popover.setOpen(this.open);
    }
  }
  onPopoverOpenChange(event2) {
    const popover = this.getPopover();
    if (event2.target !== popover) {
      return;
    }
    this.open = event2.detail.open;
  }
  static {
    _initClass2();
  }
}
export { _RuiPopoverTrigger as RuiPopoverTrigger };
function resolvePopoverAnchor(trigger) {
  const focusable = trigger.querySelector('button, a[href], input, select, textarea, [role="button"]');
  return focusable ?? trigger;
}